<template>
  <div>
    <el-row class="searc_bar_cla">
      <el-input
        style="width:40%"
        @clear="loadOptions"
        :placeholder="this.$t('common.searchValue')"
        clearable
        @keyup.enter.native="loadOptions"
        v-model="condition"
      >
        <el-button
          slot="append"
          @click.stop="loadOptions"
          icon="el-icon-search"
        ></el-button>
      </el-input>
    </el-row>

    <div>
      <el-table ref="singleTable" :data="tableData" highlight-current-row>
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column
          property="optionName"
          :label="$t('device.deviceParams')"
        ></el-table-column>
        <el-table-column
          property="optionValue"
          :label="$t('device.deviceParamsValue')"
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { loadDeviceOptions } from '@/services/deviceApi.js'

// import { getByType } from '@/cdpBase/services/dictionary.js'
export default {
  data() {
    return {
      tableData: [],
      condition: ''
    }
  },
  props: {
    devSn: {
      type: String,
      default: ''
    },
    contentHeight: {
      type: Number,
      default: 500
    }
  },
  watch: {
    devSn: {
      handler: function(val, oVal) {
        if (val) {
          this.loadOptions()
        } else {
          this.tableData = []
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // if (!this.devSn) return
    // this.loadOptions()
  },
  methods: {
    loadOptions() {
      if (!this.devSn) {
        this.$message.info(this.$t('deviceEmp.hasDevice'))
        return
      }
      let params = {
        devSn: this.devSn,
        condition: this.condition
      }
      loadDeviceOptions(params)
        .then(data => {
          if (data.code === '00000000') {
            this.tableData = data.payload.optionsList
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(e => {
          this.errorMessage()
        })
    }
  }
}
</script>

<style scoped lang="less">
.searc_bar_cla {
  margin: 5px 0px;
}
</style>



// WEBPACK FOOTER //
// src/modules/enterpriseAdmin/deviceManager/deviceCmp/deviceOptions.vue